import { render, staticRenderFns } from "./questionRank.vue?vue&type=template&id=01ac942a&"
import script from "./questionRank.vue?vue&type=script&lang=js&"
export * from "./questionRank.vue?vue&type=script&lang=js&"
import style0 from "./questionRank.vue?vue&type=style&index=0&id=01ac942a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports